export default __webpack_public_path__ + "static/media/Leggings of Bestial Rage.c4fc4908.jpg";